// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_homeScreen__Vw7RK {
  border-radius: 20.188px;
  box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);
  background-color: var(--Primary, #e7ecef);
  display: flex;
  flex-direction: column;
  min-width: 100%;
  min-height: 100%;
}

.Home_homeContainer__8EuJY {
  align-self: center;
  margin-top: 26px;
  margin-bottom: 108px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
}

.Home_homeContent__4zAun {
  gap: 20px;
  display: flex;
  min-height: 100%;
  justify-content: flex-start;
}

.Home_borrowerDashboardContainer__UZr0R {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 1100px;
}

.Home_borrowerDashboardContent__7xpj4 {
  flex-grow: 1;
  width: 1000px;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 50px;
  }
}

.Home_borrowerDashboardLayout__hLHIo {
  gap: 20px;
  display: flex;
  justify-content: center;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
}

.Home_menuContainer__KNh-2 {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 25%;
  margin-left: 0px;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
}

.Home_menuContent__ReWJF {
  display: flex;
  margin-top: 3px;
  flex-grow: 1;
  flex-direction: column;
  width: 264px;
  @media (max-width: 991px) {
    margin-top: 45px;
  }
}

.Home_selectedMenuItem__lMfLw {
  align-items: center;
  border-radius: 0px 16.842px 16.842px 0px;
  background-color: var(--Secondary, #274c77);
  align-self: stretch;
  display: flex;
  width: 100%;
  padding-top: 14px;
  padding-right: 20px;
  padding-bottom: 14px;
  flex-direction: column;
}

.Home_selectedMenuItemContent__izxni {
  align-self: center;
  display: flex;
  margin-bottom: -1px;
  width: 124px;
  max-width: 100%;
  align-items: flex-start;
  gap: 18px;
}

.Home_menuItemImg__C4IEc {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  width: 25px;
  overflow: hidden;
}

.Home_menuItemImg2__4Jtsg {
  aspect-ratio: 0.8;
  object-fit: cover;
  object-position: center;
  width: 20px;
  overflow: hidden;
}

.Home_selectedMenuItemText__S7qaM {
  color: var(--Primary, #e7ecef);
  font-family: Lato, sans-serif;
  font-size: 16.842px;
  font-weight: 600;
  align-self: flex-start;
  margin-top: auto;
  margin-bottom: auto;
  text-wrap: nowrap;
  @media (max-width: 991px) {
    text-wrap: initial;
  }
}

.Home_menuItem1__1bryM {
  align-items: center;
  border-radius: 0px 16.842px 16.842px 0px;
  background-color: var(--Primary, #e7ecef);
  align-self: stretch;
  display: flex;
  margin-top: 13px;
  width: 100%;
  padding-top: 13px;
  padding-right: 20px;
  padding-bottom: 13px;
  flex-direction: column;
}

.Home_menuItemContent1__81j1S {
  align-self: flex-start;
  display: flex;
  width: 160px;
  max-width: 100%;
  align-items: flex-start;
  gap: 18px;
  margin-left: 60px;
}

.Home_menuItemContent2__gNfzd {
  align-self: flex-start;
  display: flex;
  width: 170px;
  max-width: 100%;
  align-items: flex-start;
  gap: 18px;
  margin-left: 64px;
}

.Home_menuItemContent3__ok5z0 {
  align-self: flex-start;
  display: flex;
  margin-left: 58px;
  width: 97px;
  max-width: 100%;
  align-items: flex-start;
  gap: 14px;
  @media (max-width: 991px) {
    margin-left: 10px;
  }
}

.Home_menuItemImg3__wJ\\+-o {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  width: 25px;
  transform: rotate(-90deg);
  overflow: hidden;
}

.Home_menuItemImgDiv__8F00i {
  align-self: stretch;
  display: flex;
  flex-direction: column;
}

.Home_menuItemImg4__FKyr4 {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  width: 12px;
  fill: #274c77;
  overflow: hidden;
  align-self: center;
}

.Home_menuItemImg5__ZkkOH {
  aspect-ratio: 1.55;
  object-fit: cover;
  object-position: center;
  width: 100%;
  fill: #fff;
  overflow: hidden;
  align-self: stretch;
  margin-top: 1px;
  flex-grow: 1;
}

.Home_menuItemLabel__JdvNO {
  color: var(--Secondary, #274c77);
  font-family: Lato, sans-serif;
  font-size: 16.842px;
  font-weight: 600;
  align-self: self-start;
  margin-top: auto;
  margin-bottom: auto;
  text-wrap: nowrap;
  @media (max-width: 991px) {
    text-wrap: initial;
  }
}

.Home_myLoanerContainer__UdGXG {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 20px;
}

.Home_myLoanerContent__fClRz {
  display: flex;
  margin-top: 10px;
  flex-direction: column;
  align-self: center;
  width: 230px;
  font-size: 24px;
  justify-content: center;
}

.Home_borrowerDashboardInfoContainer__Llntr {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 66%;
}

.Home_borrowerDashboardInfoContents__F1yVB {
  display: flex;
  flex-direction: column;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 42px;
  }
}

.Home_borrowerDashboardInfoContent1__bx-YG {
  align-self: center;
  width: 571 px;
  max-width: 100%;
}

.Home_borrowerDashboardInfoContent2__bvr6j {
  align-self: center;
  margin-top: 39px;
  width: 571px;
  max-width: 100%;
}

.Home_borrowerInfo1__cZt4Y {
  gap: 20px;
  display: flex;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
}

.Home_borrowerInfoContent1__suv0x {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 0px;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
}

.Home_borrowerInfoItem2__43nK1 {
  border-radius: 16.842px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 264px;
  @media (max-width: 991px) {
    margin-top: 48px;
  }
}

.Home_borrowerInfoItem1__iahJW {
  border-radius: 16.842px;
  display: flex;
  margin-top: 3px;
  flex-grow: 1;
  flex-direction: column;
  width: 264px;
}

.Home_borrowerInfoItem3__4GEyS {
  border-radius: 16.842px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 264px;
}

.Home_borrowerInfoItem4__1TgY0 {
  border-radius: 16.842px;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  width: 264px;
}

.Home_borrowerInfoContent2__JdiqJ {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 20px;
  @media (max-width: 991px) {
    width: 100%;
    margin-left: 0;
  }
}

.Home_borrowerInfoItemBg__xKkH- {
  border-radius: 16.842px;
  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #f8f8fb);
  align-self: center;
  display: flex;
  width: 75%;
  flex-grow: 1;
  padding-top: 17px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 20px;
  flex-direction: column;
  margin-left: 30px;
}

.Home_borrowerInfoItemBg2__qUHE- {
  border-radius: 16.842px;
  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #f8f8fb);
  align-self: center;
  display: flex;
  width: 75%;
  flex-grow: 1;
  padding-top: 17px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 20px;
  flex-direction: column;
  margin-top: 6px;
}

.Home_borrowerInfoItemBg3__evWFL {
  border-radius: 16.842px;
  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #f8f8fb);
  align-self: center;
  display: flex;
  width: 75%;
  flex-grow: 1;
  padding-top: 17px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 20px;
  flex-direction: column;
  margin-left: 30px;
}

.Home_borrowerInfoItemBg4__V6xcN {
  border-radius: 16.842px;
  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #f8f8fb);
  align-self: center;
  display: flex;
  width: 75%;
  flex-grow: 1;
  padding-top: 17px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-left: 20px;
  flex-direction: column;
}

.Home_borrowerPurchaseInfo__scgQR {
  align-self: end;
  display: flex;
  margin-bottom: 9px;
  width: 190px;
  flex-direction: column;
}

.Home_borrowerInfoItemImg__qhhmZ {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  width: 17px;
  overflow: hidden;
  align-self: end;
}

.Home_borrowerPurchaseInfoTitle__izy57 {
  justify-content: center;
  color: var(--half-secondary, #516f91);
  text-align: center;
  font-family: Lato, sans-serif;
  font-size: 20.211px;
  font-weight: 700;
  align-self: center;
  margin-top: 24px;
  width: 75%;
}
.Home_borrowerPurchaseInfoBody__cNl9X {
  justify-content: center;
  color: var(--secondary-low, #879cb3);
  font-family: Lato, sans-serif;
  font-size: 11.79px;
  font-weight: 600;
  align-self: start;
  margin-top: 8px;
  width: 113px;
}

.Home_borrowerDocumentsInfo__tuBP6 {
  align-self: end;
  display: flex;
  margin-bottom: 9px;
  width: 190px;
  flex-direction: column;
}

.Home_borrowerDocumentsTitle__0IAo2 {
  justify-content: center;
  color: var(--half-secondary, #516f91);
  text-align: center;
  font-family: Lato, sans-serif;
  font-size: 20.211px;
  font-weight: 700;
  align-self: center;
  margin-top: 28px;
  width: 264px;
}

.Home_borrowerDocumentsBody__w9T8m {
  justify-content: center;
  color: #b38787;
  font-family: Lato, sans-serif;
  font-size: 11.79px;
  font-weight: 600;
  align-self: start;
  margin-top: 14px;
  margin-left: 12px;
  text-wrap: nowrap;
  @media (max-width: 991px) {
    margin-left: 10px;
    text-wrap: initial;
  }
}

.Home_borrowerFavoritesInfo__A6Vpu {
  align-self: end;
  display: flex;
  margin-bottom: 9px;
  width: 190px;
  flex-direction: column;
}

.Home_borrowerFavoritesTitle__7kYsK {
  justify-content: center;
  color: var(--half-secondary, #516f91);
  text-align: center;
  font-family: Lato, sans-serif;
  font-size: 20.211px;
  font-weight: 700;
  align-self: center;
  margin-top: 29px;
  width: 264px;
}

.Home_borrowerFavoritesBody__\\+AHXM {
  justify-content: center;
  color: #b38787;
  font-family: Lato, sans-serif;
  font-size: 11.79px;
  font-weight: 600;
  align-self: start;
  margin-top: 18px;
  margin-left: 15px;
  text-wrap: nowrap;
  @media (max-width: 991px) {
    margin-left: 10px;
    text-wrap: initial;
  }
}

.Home_borrowerResourcesInfo__Xu8rh {
  align-self: end;
  display: flex;
  margin-bottom: 9px;
  width: 190px;
  flex-direction: column;
}

.Home_borrowerResourcesTitle__z9zev {
  justify-content: start;
  color: var(--hald-secondary, #516f91);
  text-align: center;
  font-family: Lato, sans-serif;
  font-size: 20.211px;
  font-weight: 700;
  align-self: center;
  margin-top: 37px;
  width: 75%;
}

.Home_borrowerResourcesBody__qN792 {
  justify-content: center;
  color: #b38787;
  font-family: Lato, sans-serif;
  font-size: 11.79px;
  font-weight: 600;
  align-self: start;
  margin-top: 18px;
  margin-left: 20px;
  text-wrap: nowrap;
}

.Home_demoImg__uQZ4U {
  aspect-ratio: 1.96;
  object-fit: cover;
  object-position: center;
  width: 85%;
  overflow: hidden;
  align-self: center;
  margin-top: 36px;
  flex-grow: 1;
}

.Home_notificationCenterContainer__K-MRh {
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 20%;
  min-height: 100%;
}

.Home_notificationCenterContent__tLgIO {
  display: flex;
  margin-top: 3px;
  flex-direction: column;
  width: 211px;
  height: 100%;
}

.Home_notificationsContainer__H5iec {
  align-self: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.Home_notificationsContent__iWi6K {
  border-radius: 16.842px;
  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #f8f8fb);
  align-self: center;
  display: flex;
  width: 100%;
  flex-grow: 1;
  padding-top: 17px;
  padding-right: 17px;
  padding-bottom: 25px;
  padding-left: 17px;
  flex-direction: column;
}
.Home_notificationsHeader__LDkuJ {
  align-self: start;
  display: flex;
  width: 177px;
  max-width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}
.Home_notificationsTitle__mNuUL {
  justify-content: flex-end;
  color: var(--Secondary, #274c77);
  font-family: Lato, sans-serif;
  font-size: 15.158px;
  font-weight: 800;
  align-self: start;
  margin-top: 8px;
}
.Home_notificationsHeaderImg__p0gmb {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  width: 17px;
  overflow: hidden;
  align-self: start;
}

.Home_notificationItem__6BHyV {
  align-self: start;
  display: flex;
  margin-top: 31px;
  width: 138px;
  max-width: 100%;
  align-items: flex-start;
  gap: 13px;
}
.Home_notificationItem2__TeSqM {
  align-self: start;
  display: flex;
  margin-top: 21px;
  width: 165px;
  max-width: 100%;
  align-items: flex-start;
  gap: 13px;
}

.Home_notificationItemImg__ZadPh {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  width: 8px;
  fill: var(--red, #9b4343);
  margin-top: 1px;
}
.Home_notificationItemImg2__sDstr {
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
  width: 8px;
  fill: var(--Green, #439b57);
  align-self: start;
  margin-top: 1px;
}

.Home_notificationMsg__U-ie2 {
  color: var(--half-secondary, #516f91);
  font-family: Lato, sans-serif;
  font-size: 13.474px;
  font-weight: 600;
  align-self: stretch;
  text-wrap: nowrap;
  text-align: left;
  @media (max-width: 991px) {
    text-wrap: initial;
  }
}
.Home_notificationMsg2__HRc5r {
  color: var(--half-secondary, #516f91);
  font-family: Lato, sans-serif;
  font-size: 13.474px;
  font-weight: 600;
  align-self: start;
  text-wrap: nowrap;
  text-align: left;
  @media (max-width: 991px) {
    text-wrap: initial;
  }
}

.Home_notificationMsg3__ND5Q3 {
  color: var(--half-secondary, #516f91);
  font-family: Lato, sans-serif;
  font-size: 13.474px;
  font-weight: 600;
  line-height: 170%;
  align-self: start;
  width: 155px;
  max-width: 100%;
  text-align: left;
}

.Home_notificationTime__-oESM {
  color: var(--secondary-low, #879cb3);
  font-family: Lato, sans-serif;
  font-size: 11.79px;
  font-weight: 500;
  align-self: start;
  margin-top: 11px;
  margin-left: 21px;
  text-wrap: nowrap;
  @media (max-width: 991px) {
    margin-left: 10px;
    text-wrap: initial;
  }
}
.Home_notificationTime2__3b0vf {
  color: var(--secondary-low, #879cb3);
  font-family: Lato, sans-serif;
  font-size: 11.79px;
  font-weight: 500;
  align-self: start;
  margin-top: 11px;
  text-wrap: nowrap;
  @media (max-width: 991px) {
    margin-left: 10px;
    text-wrap: initial;
  }
}

.Home_notificationItem3__tW1bW {
  align-self: start;
  display: flex;
  flex-direction: column;
}

.Home_notificationCenterDivider__1vCxj {
  align-self: center;
  display: flex;
  margin-top: 41px;
  flex-grow: 1;
  flex-direction: column;
  width: 100%;
}

.Home_pendingTasksContainer__V8aN2 {
  border-radius: 16.842px;
  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
  background-color: var(--boxes, #f8f8fb);
  align-self: center;
  display: flex;
  width: 100%;
  flex-grow: 1;
  padding-top: 25px;
  padding-right: 20px;
  padding-bottom: 40px;
  padding-left: 17px;
  flex-direction: column;
}

.Home_pendingTasksContent__-oKkc {
  align-self: start;
  display: flex;
  margin-bottom: 19px;
  width: 147px;
  max-width: 100%;
  flex-direction: column;
}

.Home_pendingTasksTitle__2\\+d1V {
  justify-content: flex-end;
  color: var(--Secondary, #274c77);
  font-family: Lato, sans-serif;
  font-size: 15.158px;
  font-weight: 800;
  align-self: start;
  text-wrap: nowrap;
  @media (max-width: 991px) {
    text-wrap: initial;
  }
}

.Home_pendingTaskItem__QjKTE {
  color: var(--half-secondary, #516f91);
  font-family: Lato, sans-serif;
  font-size: 13.474px;
  font-weight: 600;
  align-self: start;
  margin-top: 34px;
  margin-left: 25px;
  text-wrap: nowrap;
  text-align: left;
  @media (max-width: 991px) {
    text-wrap: initial;
  }
}

.Home_settingsDiv__\\+My3n {
  align-self: center;
  display: flex;
  margin-left: -26px;
  margin-bottom: -1px;
  width: 103px;
  max-width: 100%;
  align-items: flex-start;
  gap: 18px;
}

.Home_settingsDiv2__LurJU {
  align-items: center;
  border-radius: 0px 16.842px 16.842px 0px;
  background-color: var(--Primary, #e7ecef);
  align-self: stretch;
  display: flex;
  margin-top: 84px;
  width: 100%;
  flex-grow: 1;
  padding-top: 14px;
  padding-right: 20px;
  padding-bottom: 14px;
  padding-left: 20px;
  flex-direction: column;
}

.Home_sidebar__x2zrk{
  display: flex;
  width: 264px;
  flex-direction: column;
}

.Home_sidebar__x2zrk a {
  align-items: center;
  border-radius: 0px 16.842px 16.842px 0px;
  align-self: stretch;
  display: flex;
  padding-top: 13px;
  padding-right: 20px;
  padding-bottom: 13px;
  padding-left: 20px;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
  height: 100%;
  text-decoration: none;
}

.Home_sidebar__x2zrk a.Home_active__02NER {
  align-items: center;
  border-radius: 0px 16.842px 16.842px 0px;
  background-color: var(--Secondary, #274C77);
  align-self: stretch;
  display: flex;
  width: 100%;
  padding-top: 13px;
  padding-right: 20px;
  padding-bottom: 13px;
  padding-left: 20px;
  flex-direction: column;
}

.Home_sidebar__x2zrk a:hover:not(.Home_active__02NER) {
  background-color: #274c7742;
  color: white;
  align-items: center;
  border-radius: 0px 16.842px 16.842px 0px;
  align-self: stretch;
  display: flex;
  padding-top: 13px;
  padding-right: 20px;
  padding-bottom: 13px;
  padding-left: 20px;
  flex-direction: column;
}

.Home_menuOptionTextDiv__6pKXS{
  align-self: center;
  display: flex;
  margin-left: -16px;
  width: 200px;
  max-width: 100%;
  align-items: flex-start;
  gap: 18px;
  margin-top: auto;
  margin-bottom: auto;
}

.Home_menuIcon__n6jrL {
  aspect-ratio: 0.96;
  object-fit: cover;
  object-position: center;
  width: 25px;
  overflow: hidden;
  align-self: start;
}

.Home_menuOptionText__COvKK{
  color: var(--Primary, #E7ECEF);
  font-family:
      Lato, sans-serif;
  font-size: 16.842px;
  font-weight: 600;
  align-self: center;
  margin-top: auto;
  margin-bottom: auto;
  text-wrap: nowrap;
  @media (max-width: 991px) {
      textWrap: initial
  }
}

.Home_menuOptionTextNotActive__Sv6IB{
  color: var(--Primary, #E7ECEF);
  font-family:
      Lato, sans-serif;
  font-size: 16.842px;
  font-weight: 600;
  align-self: center;
  margin-top: auto;
  margin-bottom: auto;
  text-wrap: nowrap;
  @media (max-width: 991px) {
      textWrap: initial
  }
  color: var(--Secondary, #274C77);
}`, "",{"version":3,"sources":["webpack://./src/components/Home.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;EACb;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB;IACE,kBAAkB;EACpB;AACF;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wEAAwE;EACxE,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B;sBACoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB;MACI;EACJ;AACF;;AAEA;EACE,8BAA8B;EAC9B;sBACoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB;MACI;EACJ;EACA,gCAAgC;AAClC","sourcesContent":[".homeScreen {\n  border-radius: 20.188px;\n  box-shadow: 0px 26.83224px 53.66447px -3.88876px rgba(39, 76, 119, 0.36);\n  background-color: var(--Primary, #e7ecef);\n  display: flex;\n  flex-direction: column;\n  min-width: 100%;\n  min-height: 100%;\n}\n\n.homeContainer {\n  align-self: center;\n  margin-top: 26px;\n  margin-bottom: 108px;\n  width: 100%;\n  @media (max-width: 991px) {\n    max-width: 100%;\n  }\n}\n\n.homeContent {\n  gap: 20px;\n  display: flex;\n  min-height: 100%;\n  justify-content: flex-start;\n}\n\n.borrowerDashboardContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 1100px;\n}\n\n.borrowerDashboardContent {\n  flex-grow: 1;\n  width: 1000px;\n  @media (max-width: 991px) {\n    max-width: 100%;\n    margin-top: 50px;\n  }\n}\n\n.borrowerDashboardLayout {\n  gap: 20px;\n  display: flex;\n  justify-content: center;\n  @media (max-width: 991px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0px;\n  }\n}\n\n.menuContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 25%;\n  margin-left: 0px;\n  @media (max-width: 991px) {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n.menuContent {\n  display: flex;\n  margin-top: 3px;\n  flex-grow: 1;\n  flex-direction: column;\n  width: 264px;\n  @media (max-width: 991px) {\n    margin-top: 45px;\n  }\n}\n\n.selectedMenuItem {\n  align-items: center;\n  border-radius: 0px 16.842px 16.842px 0px;\n  background-color: var(--Secondary, #274c77);\n  align-self: stretch;\n  display: flex;\n  width: 100%;\n  padding-top: 14px;\n  padding-right: 20px;\n  padding-bottom: 14px;\n  flex-direction: column;\n}\n\n.selectedMenuItemContent {\n  align-self: center;\n  display: flex;\n  margin-bottom: -1px;\n  width: 124px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 18px;\n}\n\n.menuItemImg {\n  aspect-ratio: 1;\n  object-fit: cover;\n  object-position: center;\n  width: 25px;\n  overflow: hidden;\n}\n\n.menuItemImg2 {\n  aspect-ratio: 0.8;\n  object-fit: cover;\n  object-position: center;\n  width: 20px;\n  overflow: hidden;\n}\n\n.selectedMenuItemText {\n  color: var(--Primary, #e7ecef);\n  font-family: Lato, sans-serif;\n  font-size: 16.842px;\n  font-weight: 600;\n  align-self: flex-start;\n  margin-top: auto;\n  margin-bottom: auto;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n    text-wrap: initial;\n  }\n}\n\n.menuItem1 {\n  align-items: center;\n  border-radius: 0px 16.842px 16.842px 0px;\n  background-color: var(--Primary, #e7ecef);\n  align-self: stretch;\n  display: flex;\n  margin-top: 13px;\n  width: 100%;\n  padding-top: 13px;\n  padding-right: 20px;\n  padding-bottom: 13px;\n  flex-direction: column;\n}\n\n.menuItemContent1 {\n  align-self: flex-start;\n  display: flex;\n  width: 160px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 18px;\n  margin-left: 60px;\n}\n\n.menuItemContent2 {\n  align-self: flex-start;\n  display: flex;\n  width: 170px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 18px;\n  margin-left: 64px;\n}\n\n.menuItemContent3 {\n  align-self: flex-start;\n  display: flex;\n  margin-left: 58px;\n  width: 97px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 14px;\n  @media (max-width: 991px) {\n    margin-left: 10px;\n  }\n}\n\n.menuItemImg3 {\n  aspect-ratio: 1;\n  object-fit: cover;\n  object-position: center;\n  width: 25px;\n  transform: rotate(-90deg);\n  overflow: hidden;\n}\n\n.menuItemImgDiv {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n}\n\n.menuItemImg4 {\n  aspect-ratio: 1;\n  object-fit: cover;\n  object-position: center;\n  width: 12px;\n  fill: #274c77;\n  overflow: hidden;\n  align-self: center;\n}\n\n.menuItemImg5 {\n  aspect-ratio: 1.55;\n  object-fit: cover;\n  object-position: center;\n  width: 100%;\n  fill: #fff;\n  overflow: hidden;\n  align-self: stretch;\n  margin-top: 1px;\n  flex-grow: 1;\n}\n\n.menuItemLabel {\n  color: var(--Secondary, #274c77);\n  font-family: Lato, sans-serif;\n  font-size: 16.842px;\n  font-weight: 600;\n  align-self: self-start;\n  margin-top: auto;\n  margin-bottom: auto;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n    text-wrap: initial;\n  }\n}\n\n.myLoanerContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 20px;\n}\n\n.myLoanerContent {\n  display: flex;\n  margin-top: 10px;\n  flex-direction: column;\n  align-self: center;\n  width: 230px;\n  font-size: 24px;\n  justify-content: center;\n}\n\n.borrowerDashboardInfoContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 66%;\n}\n\n.borrowerDashboardInfoContents {\n  display: flex;\n  flex-direction: column;\n  @media (max-width: 991px) {\n    max-width: 100%;\n    margin-top: 42px;\n  }\n}\n\n.borrowerDashboardInfoContent1 {\n  align-self: center;\n  width: 571 px;\n  max-width: 100%;\n}\n\n.borrowerDashboardInfoContent2 {\n  align-self: center;\n  margin-top: 39px;\n  width: 571px;\n  max-width: 100%;\n}\n\n.borrowerInfo1 {\n  gap: 20px;\n  display: flex;\n  @media (max-width: 991px) {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0px;\n  }\n}\n\n.borrowerInfoContent1 {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 50%;\n  margin-left: 0px;\n  @media (max-width: 991px) {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n.borrowerInfoItem2 {\n  border-radius: 16.842px;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  width: 264px;\n  @media (max-width: 991px) {\n    margin-top: 48px;\n  }\n}\n\n.borrowerInfoItem1 {\n  border-radius: 16.842px;\n  display: flex;\n  margin-top: 3px;\n  flex-grow: 1;\n  flex-direction: column;\n  width: 264px;\n}\n\n.borrowerInfoItem3 {\n  border-radius: 16.842px;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  width: 264px;\n}\n\n.borrowerInfoItem4 {\n  border-radius: 16.842px;\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  width: 264px;\n}\n\n.borrowerInfoContent2 {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 50%;\n  margin-left: 20px;\n  @media (max-width: 991px) {\n    width: 100%;\n    margin-left: 0;\n  }\n}\n\n.borrowerInfoItemBg {\n  border-radius: 16.842px;\n  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #f8f8fb);\n  align-self: center;\n  display: flex;\n  width: 75%;\n  flex-grow: 1;\n  padding-top: 17px;\n  padding-right: 16px;\n  padding-bottom: 40px;\n  padding-left: 20px;\n  flex-direction: column;\n  margin-left: 30px;\n}\n\n.borrowerInfoItemBg2 {\n  border-radius: 16.842px;\n  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #f8f8fb);\n  align-self: center;\n  display: flex;\n  width: 75%;\n  flex-grow: 1;\n  padding-top: 17px;\n  padding-right: 16px;\n  padding-bottom: 40px;\n  padding-left: 20px;\n  flex-direction: column;\n  margin-top: 6px;\n}\n\n.borrowerInfoItemBg3 {\n  border-radius: 16.842px;\n  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #f8f8fb);\n  align-self: center;\n  display: flex;\n  width: 75%;\n  flex-grow: 1;\n  padding-top: 17px;\n  padding-right: 16px;\n  padding-bottom: 40px;\n  padding-left: 20px;\n  flex-direction: column;\n  margin-left: 30px;\n}\n\n.borrowerInfoItemBg4 {\n  border-radius: 16.842px;\n  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #f8f8fb);\n  align-self: center;\n  display: flex;\n  width: 75%;\n  flex-grow: 1;\n  padding-top: 17px;\n  padding-right: 16px;\n  padding-bottom: 40px;\n  padding-left: 20px;\n  flex-direction: column;\n}\n\n.borrowerPurchaseInfo {\n  align-self: end;\n  display: flex;\n  margin-bottom: 9px;\n  width: 190px;\n  flex-direction: column;\n}\n\n.borrowerInfoItemImg {\n  aspect-ratio: 1;\n  object-fit: cover;\n  object-position: center;\n  width: 17px;\n  overflow: hidden;\n  align-self: end;\n}\n\n.borrowerPurchaseInfoTitle {\n  justify-content: center;\n  color: var(--half-secondary, #516f91);\n  text-align: center;\n  font-family: Lato, sans-serif;\n  font-size: 20.211px;\n  font-weight: 700;\n  align-self: center;\n  margin-top: 24px;\n  width: 75%;\n}\n.borrowerPurchaseInfoBody {\n  justify-content: center;\n  color: var(--secondary-low, #879cb3);\n  font-family: Lato, sans-serif;\n  font-size: 11.79px;\n  font-weight: 600;\n  align-self: start;\n  margin-top: 8px;\n  width: 113px;\n}\n\n.borrowerDocumentsInfo {\n  align-self: end;\n  display: flex;\n  margin-bottom: 9px;\n  width: 190px;\n  flex-direction: column;\n}\n\n.borrowerDocumentsTitle {\n  justify-content: center;\n  color: var(--half-secondary, #516f91);\n  text-align: center;\n  font-family: Lato, sans-serif;\n  font-size: 20.211px;\n  font-weight: 700;\n  align-self: center;\n  margin-top: 28px;\n  width: 264px;\n}\n\n.borrowerDocumentsBody {\n  justify-content: center;\n  color: #b38787;\n  font-family: Lato, sans-serif;\n  font-size: 11.79px;\n  font-weight: 600;\n  align-self: start;\n  margin-top: 14px;\n  margin-left: 12px;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n    margin-left: 10px;\n    text-wrap: initial;\n  }\n}\n\n.borrowerFavoritesInfo {\n  align-self: end;\n  display: flex;\n  margin-bottom: 9px;\n  width: 190px;\n  flex-direction: column;\n}\n\n.borrowerFavoritesTitle {\n  justify-content: center;\n  color: var(--half-secondary, #516f91);\n  text-align: center;\n  font-family: Lato, sans-serif;\n  font-size: 20.211px;\n  font-weight: 700;\n  align-self: center;\n  margin-top: 29px;\n  width: 264px;\n}\n\n.borrowerFavoritesBody {\n  justify-content: center;\n  color: #b38787;\n  font-family: Lato, sans-serif;\n  font-size: 11.79px;\n  font-weight: 600;\n  align-self: start;\n  margin-top: 18px;\n  margin-left: 15px;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n    margin-left: 10px;\n    text-wrap: initial;\n  }\n}\n\n.borrowerResourcesInfo {\n  align-self: end;\n  display: flex;\n  margin-bottom: 9px;\n  width: 190px;\n  flex-direction: column;\n}\n\n.borrowerResourcesTitle {\n  justify-content: start;\n  color: var(--hald-secondary, #516f91);\n  text-align: center;\n  font-family: Lato, sans-serif;\n  font-size: 20.211px;\n  font-weight: 700;\n  align-self: center;\n  margin-top: 37px;\n  width: 75%;\n}\n\n.borrowerResourcesBody {\n  justify-content: center;\n  color: #b38787;\n  font-family: Lato, sans-serif;\n  font-size: 11.79px;\n  font-weight: 600;\n  align-self: start;\n  margin-top: 18px;\n  margin-left: 20px;\n  text-wrap: nowrap;\n}\n\n.demoImg {\n  aspect-ratio: 1.96;\n  object-fit: cover;\n  object-position: center;\n  width: 85%;\n  overflow: hidden;\n  align-self: center;\n  margin-top: 36px;\n  flex-grow: 1;\n}\n\n.notificationCenterContainer {\n  display: flex;\n  flex-direction: column;\n  line-height: normal;\n  width: 20%;\n  min-height: 100%;\n}\n\n.notificationCenterContent {\n  display: flex;\n  margin-top: 3px;\n  flex-direction: column;\n  width: 211px;\n  height: 100%;\n}\n\n.notificationsContainer {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.notificationsContent {\n  border-radius: 16.842px;\n  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #f8f8fb);\n  align-self: center;\n  display: flex;\n  width: 100%;\n  flex-grow: 1;\n  padding-top: 17px;\n  padding-right: 17px;\n  padding-bottom: 25px;\n  padding-left: 17px;\n  flex-direction: column;\n}\n.notificationsHeader {\n  align-self: start;\n  display: flex;\n  width: 177px;\n  max-width: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n}\n.notificationsTitle {\n  justify-content: flex-end;\n  color: var(--Secondary, #274c77);\n  font-family: Lato, sans-serif;\n  font-size: 15.158px;\n  font-weight: 800;\n  align-self: start;\n  margin-top: 8px;\n}\n.notificationsHeaderImg {\n  aspect-ratio: 1;\n  object-fit: cover;\n  object-position: center;\n  width: 17px;\n  overflow: hidden;\n  align-self: start;\n}\n\n.notificationItem {\n  align-self: start;\n  display: flex;\n  margin-top: 31px;\n  width: 138px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 13px;\n}\n.notificationItem2 {\n  align-self: start;\n  display: flex;\n  margin-top: 21px;\n  width: 165px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 13px;\n}\n\n.notificationItemImg {\n  aspect-ratio: 1;\n  object-fit: cover;\n  object-position: center;\n  width: 8px;\n  fill: var(--red, #9b4343);\n  margin-top: 1px;\n}\n.notificationItemImg2 {\n  aspect-ratio: 1;\n  object-fit: cover;\n  object-position: center;\n  width: 8px;\n  fill: var(--Green, #439b57);\n  align-self: start;\n  margin-top: 1px;\n}\n\n.notificationMsg {\n  color: var(--half-secondary, #516f91);\n  font-family: Lato, sans-serif;\n  font-size: 13.474px;\n  font-weight: 600;\n  align-self: stretch;\n  text-wrap: nowrap;\n  text-align: left;\n  @media (max-width: 991px) {\n    text-wrap: initial;\n  }\n}\n.notificationMsg2 {\n  color: var(--half-secondary, #516f91);\n  font-family: Lato, sans-serif;\n  font-size: 13.474px;\n  font-weight: 600;\n  align-self: start;\n  text-wrap: nowrap;\n  text-align: left;\n  @media (max-width: 991px) {\n    text-wrap: initial;\n  }\n}\n\n.notificationMsg3 {\n  color: var(--half-secondary, #516f91);\n  font-family: Lato, sans-serif;\n  font-size: 13.474px;\n  font-weight: 600;\n  line-height: 170%;\n  align-self: start;\n  width: 155px;\n  max-width: 100%;\n  text-align: left;\n}\n\n.notificationTime {\n  color: var(--secondary-low, #879cb3);\n  font-family: Lato, sans-serif;\n  font-size: 11.79px;\n  font-weight: 500;\n  align-self: start;\n  margin-top: 11px;\n  margin-left: 21px;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n    margin-left: 10px;\n    text-wrap: initial;\n  }\n}\n.notificationTime2 {\n  color: var(--secondary-low, #879cb3);\n  font-family: Lato, sans-serif;\n  font-size: 11.79px;\n  font-weight: 500;\n  align-self: start;\n  margin-top: 11px;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n    margin-left: 10px;\n    text-wrap: initial;\n  }\n}\n\n.notificationItem3 {\n  align-self: start;\n  display: flex;\n  flex-direction: column;\n}\n\n.notificationCenterDivider {\n  align-self: center;\n  display: flex;\n  margin-top: 41px;\n  flex-grow: 1;\n  flex-direction: column;\n  width: 100%;\n}\n\n.pendingTasksContainer {\n  border-radius: 16.842px;\n  box-shadow: 0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n  background-color: var(--boxes, #f8f8fb);\n  align-self: center;\n  display: flex;\n  width: 100%;\n  flex-grow: 1;\n  padding-top: 25px;\n  padding-right: 20px;\n  padding-bottom: 40px;\n  padding-left: 17px;\n  flex-direction: column;\n}\n\n.pendingTasksContent {\n  align-self: start;\n  display: flex;\n  margin-bottom: 19px;\n  width: 147px;\n  max-width: 100%;\n  flex-direction: column;\n}\n\n.pendingTasksTitle {\n  justify-content: flex-end;\n  color: var(--Secondary, #274c77);\n  font-family: Lato, sans-serif;\n  font-size: 15.158px;\n  font-weight: 800;\n  align-self: start;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n    text-wrap: initial;\n  }\n}\n\n.pendingTaskItem {\n  color: var(--half-secondary, #516f91);\n  font-family: Lato, sans-serif;\n  font-size: 13.474px;\n  font-weight: 600;\n  align-self: start;\n  margin-top: 34px;\n  margin-left: 25px;\n  text-wrap: nowrap;\n  text-align: left;\n  @media (max-width: 991px) {\n    text-wrap: initial;\n  }\n}\n\n.settingsDiv {\n  align-self: center;\n  display: flex;\n  margin-left: -26px;\n  margin-bottom: -1px;\n  width: 103px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 18px;\n}\n\n.settingsDiv2 {\n  align-items: center;\n  border-radius: 0px 16.842px 16.842px 0px;\n  background-color: var(--Primary, #e7ecef);\n  align-self: stretch;\n  display: flex;\n  margin-top: 84px;\n  width: 100%;\n  flex-grow: 1;\n  padding-top: 14px;\n  padding-right: 20px;\n  padding-bottom: 14px;\n  padding-left: 20px;\n  flex-direction: column;\n}\n\n.sidebar{\n  display: flex;\n  width: 264px;\n  flex-direction: column;\n}\n\n.sidebar a {\n  align-items: center;\n  border-radius: 0px 16.842px 16.842px 0px;\n  align-self: stretch;\n  display: flex;\n  padding-top: 13px;\n  padding-right: 20px;\n  padding-bottom: 13px;\n  padding-left: 20px;\n  flex-direction: column;\n  margin-top: 10px;\n  width: 100%;\n  height: 100%;\n  text-decoration: none;\n}\n\n.sidebar a.active {\n  align-items: center;\n  border-radius: 0px 16.842px 16.842px 0px;\n  background-color: var(--Secondary, #274C77);\n  align-self: stretch;\n  display: flex;\n  width: 100%;\n  padding-top: 13px;\n  padding-right: 20px;\n  padding-bottom: 13px;\n  padding-left: 20px;\n  flex-direction: column;\n}\n\n.sidebar a:hover:not(.active) {\n  background-color: #274c7742;\n  color: white;\n  align-items: center;\n  border-radius: 0px 16.842px 16.842px 0px;\n  align-self: stretch;\n  display: flex;\n  padding-top: 13px;\n  padding-right: 20px;\n  padding-bottom: 13px;\n  padding-left: 20px;\n  flex-direction: column;\n}\n\n.menuOptionTextDiv{\n  align-self: center;\n  display: flex;\n  margin-left: -16px;\n  width: 200px;\n  max-width: 100%;\n  align-items: flex-start;\n  gap: 18px;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.menuIcon {\n  aspect-ratio: 0.96;\n  object-fit: cover;\n  object-position: center;\n  width: 25px;\n  overflow: hidden;\n  align-self: start;\n}\n\n.menuOptionText{\n  color: var(--Primary, #E7ECEF);\n  font-family:\n      Lato, sans-serif;\n  font-size: 16.842px;\n  font-weight: 600;\n  align-self: center;\n  margin-top: auto;\n  margin-bottom: auto;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n      textWrap: initial\n  }\n}\n\n.menuOptionTextNotActive{\n  color: var(--Primary, #E7ECEF);\n  font-family:\n      Lato, sans-serif;\n  font-size: 16.842px;\n  font-weight: 600;\n  align-self: center;\n  margin-top: auto;\n  margin-bottom: auto;\n  text-wrap: nowrap;\n  @media (max-width: 991px) {\n      textWrap: initial\n  }\n  color: var(--Secondary, #274C77);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeScreen": `Home_homeScreen__Vw7RK`,
	"homeContainer": `Home_homeContainer__8EuJY`,
	"homeContent": `Home_homeContent__4zAun`,
	"borrowerDashboardContainer": `Home_borrowerDashboardContainer__UZr0R`,
	"borrowerDashboardContent": `Home_borrowerDashboardContent__7xpj4`,
	"borrowerDashboardLayout": `Home_borrowerDashboardLayout__hLHIo`,
	"menuContainer": `Home_menuContainer__KNh-2`,
	"menuContent": `Home_menuContent__ReWJF`,
	"selectedMenuItem": `Home_selectedMenuItem__lMfLw`,
	"selectedMenuItemContent": `Home_selectedMenuItemContent__izxni`,
	"menuItemImg": `Home_menuItemImg__C4IEc`,
	"menuItemImg2": `Home_menuItemImg2__4Jtsg`,
	"selectedMenuItemText": `Home_selectedMenuItemText__S7qaM`,
	"menuItem1": `Home_menuItem1__1bryM`,
	"menuItemContent1": `Home_menuItemContent1__81j1S`,
	"menuItemContent2": `Home_menuItemContent2__gNfzd`,
	"menuItemContent3": `Home_menuItemContent3__ok5z0`,
	"menuItemImg3": `Home_menuItemImg3__wJ+-o`,
	"menuItemImgDiv": `Home_menuItemImgDiv__8F00i`,
	"menuItemImg4": `Home_menuItemImg4__FKyr4`,
	"menuItemImg5": `Home_menuItemImg5__ZkkOH`,
	"menuItemLabel": `Home_menuItemLabel__JdvNO`,
	"myLoanerContainer": `Home_myLoanerContainer__UdGXG`,
	"myLoanerContent": `Home_myLoanerContent__fClRz`,
	"borrowerDashboardInfoContainer": `Home_borrowerDashboardInfoContainer__Llntr`,
	"borrowerDashboardInfoContents": `Home_borrowerDashboardInfoContents__F1yVB`,
	"borrowerDashboardInfoContent1": `Home_borrowerDashboardInfoContent1__bx-YG`,
	"borrowerDashboardInfoContent2": `Home_borrowerDashboardInfoContent2__bvr6j`,
	"borrowerInfo1": `Home_borrowerInfo1__cZt4Y`,
	"borrowerInfoContent1": `Home_borrowerInfoContent1__suv0x`,
	"borrowerInfoItem2": `Home_borrowerInfoItem2__43nK1`,
	"borrowerInfoItem1": `Home_borrowerInfoItem1__iahJW`,
	"borrowerInfoItem3": `Home_borrowerInfoItem3__4GEyS`,
	"borrowerInfoItem4": `Home_borrowerInfoItem4__1TgY0`,
	"borrowerInfoContent2": `Home_borrowerInfoContent2__JdiqJ`,
	"borrowerInfoItemBg": `Home_borrowerInfoItemBg__xKkH-`,
	"borrowerInfoItemBg2": `Home_borrowerInfoItemBg2__qUHE-`,
	"borrowerInfoItemBg3": `Home_borrowerInfoItemBg3__evWFL`,
	"borrowerInfoItemBg4": `Home_borrowerInfoItemBg4__V6xcN`,
	"borrowerPurchaseInfo": `Home_borrowerPurchaseInfo__scgQR`,
	"borrowerInfoItemImg": `Home_borrowerInfoItemImg__qhhmZ`,
	"borrowerPurchaseInfoTitle": `Home_borrowerPurchaseInfoTitle__izy57`,
	"borrowerPurchaseInfoBody": `Home_borrowerPurchaseInfoBody__cNl9X`,
	"borrowerDocumentsInfo": `Home_borrowerDocumentsInfo__tuBP6`,
	"borrowerDocumentsTitle": `Home_borrowerDocumentsTitle__0IAo2`,
	"borrowerDocumentsBody": `Home_borrowerDocumentsBody__w9T8m`,
	"borrowerFavoritesInfo": `Home_borrowerFavoritesInfo__A6Vpu`,
	"borrowerFavoritesTitle": `Home_borrowerFavoritesTitle__7kYsK`,
	"borrowerFavoritesBody": `Home_borrowerFavoritesBody__+AHXM`,
	"borrowerResourcesInfo": `Home_borrowerResourcesInfo__Xu8rh`,
	"borrowerResourcesTitle": `Home_borrowerResourcesTitle__z9zev`,
	"borrowerResourcesBody": `Home_borrowerResourcesBody__qN792`,
	"demoImg": `Home_demoImg__uQZ4U`,
	"notificationCenterContainer": `Home_notificationCenterContainer__K-MRh`,
	"notificationCenterContent": `Home_notificationCenterContent__tLgIO`,
	"notificationsContainer": `Home_notificationsContainer__H5iec`,
	"notificationsContent": `Home_notificationsContent__iWi6K`,
	"notificationsHeader": `Home_notificationsHeader__LDkuJ`,
	"notificationsTitle": `Home_notificationsTitle__mNuUL`,
	"notificationsHeaderImg": `Home_notificationsHeaderImg__p0gmb`,
	"notificationItem": `Home_notificationItem__6BHyV`,
	"notificationItem2": `Home_notificationItem2__TeSqM`,
	"notificationItemImg": `Home_notificationItemImg__ZadPh`,
	"notificationItemImg2": `Home_notificationItemImg2__sDstr`,
	"notificationMsg": `Home_notificationMsg__U-ie2`,
	"notificationMsg2": `Home_notificationMsg2__HRc5r`,
	"notificationMsg3": `Home_notificationMsg3__ND5Q3`,
	"notificationTime": `Home_notificationTime__-oESM`,
	"notificationTime2": `Home_notificationTime2__3b0vf`,
	"notificationItem3": `Home_notificationItem3__tW1bW`,
	"notificationCenterDivider": `Home_notificationCenterDivider__1vCxj`,
	"pendingTasksContainer": `Home_pendingTasksContainer__V8aN2`,
	"pendingTasksContent": `Home_pendingTasksContent__-oKkc`,
	"pendingTasksTitle": `Home_pendingTasksTitle__2+d1V`,
	"pendingTaskItem": `Home_pendingTaskItem__QjKTE`,
	"settingsDiv": `Home_settingsDiv__+My3n`,
	"settingsDiv2": `Home_settingsDiv2__LurJU`,
	"sidebar": `Home_sidebar__x2zrk`,
	"active": `Home_active__02NER`,
	"menuOptionTextDiv": `Home_menuOptionTextDiv__6pKXS`,
	"menuIcon": `Home_menuIcon__n6jrL`,
	"menuOptionText": `Home_menuOptionText__COvKK`,
	"menuOptionTextNotActive": `Home_menuOptionTextNotActive__Sv6IB`
};
export default ___CSS_LOADER_EXPORT___;
